import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    settings: {
      market_scope_choice: "system",
      market_region: 10000002,
      market_system: 30000142,
      market_type: "sell",
      market_price: "weightedAverage",
      r_yield: 0.5,
    }
  },
  mutations: {
    /**
     * Retrieve the state from the device storage.
     *
     * @param {*} state
     */
    INITIALISE_STATE(state) {
      // Check if the ID exists
      if (localStorage.getItem('state')) {
        // Replace the state object with the stored item
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('state')))
        );
      }
    },

    CHANGE_MARKET_SCOPE_CHOICE(state, newValue) {
      state.settings.market_scope_choice = newValue;
    },
    CHANGE_MARKET_REGION(state, newValue) {
      state.settings.market_region = newValue;
    },
    CHANGE_MARKET_SYSTEM(state, newValue) {
      state.settings.market_system = newValue;
    },
    CHANGE_MARKET_TYPE(state, newValue) {
      state.settings.market_type = newValue;
    },
    CHANGE_MARKET_PRICE(state, newValue) {
      state.settings.market_price = newValue;
    },
    CHANGE_REPROCESSING_YIELD(state, newValue) {
      state.settings.r_yield= newValue;
    }
  },
});
